// assets/related-collection-chips.js (Full script with added logging)

document.addEventListener('DOMContentLoaded', () => {
  //console.log('[Chips Full] DOMContentLoaded fired.'); // 1
  const chipsContainer = document.getElementById('related-collection-chips-container');

  if (!chipsContainer) {
   // console.error('[Chips Full] ERROR: Container element not found.'); // Should not happen based on previous test
    return;
  }
 // console.log('[Chips Full] Found container element:', chipsContainer); // 2

  // Get API details and JSON URL
  const shopDomain = chipsContainer.dataset.shopDomain;
  const storefrontAccessToken = chipsContainer.dataset.storefrontToken;
  const apiVersion = chipsContainer.dataset.apiVersion;
  const currentCollectionId = chipsContainer.dataset.currentCollectionId;
  const jsonUrl = chipsContainer.dataset.jsonUrl;
  console.log('[Chips Full] Config:', { shopDomain, storefrontAccessToken, apiVersion, currentCollectionId, jsonUrl }); // 3

  // --- Basic Validation ---
  if (!shopDomain || !storefrontAccessToken || !apiVersion || !jsonUrl) {
    console.error('[Chips Full] ERROR: Missing critical data attributes.');
    chipsContainer.innerHTML = '<p style="color: red;">Error: Missing configuration.</p>';
    return;
  }
   if (storefrontAccessToken === 'YOUR_STOREFRONT_API_ACCESS_TOKEN') {
     console.warn('[Chips Full] WARNING: Placeholder Storefront Access Token found.');
     chipsContainer.innerHTML = '<p style="color: orange;">Warning: API token not set.</p>';
     // return; // Optional: stop execution if token is placeholder
   }
  // --- End Validation ---

  const GET_COLLECTION_HANDLE_QUERY = `
    query GetCollectionHandle($collectionId: ID!) {
      collection(id: $collectionId) {
        handle
      }
    }
  `;

// --- Function to Fetch JSON and Render Chips ---
  async function loadAndRenderChips() {
    // console.log('[Chips Full] Starting loadAndRenderChips(). Fetching JSON from:', jsonUrl); // Optional: Keep debug logs if helpful
    try {
      const response = await fetch(jsonUrl);
      // console.log('[Chips Full] JSON fetch response status:', response.status, 'OK:', response.ok);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status} while fetching ${jsonUrl}`);
      }

      const relatedCollectionsData = await response.json();
      // console.log('[Chips Full] Successfully parsed JSON data:', relatedCollectionsData);

      if (currentCollectionId && relatedCollectionsData[currentCollectionId]) {
        // console.log(`[Chips Full] Found data for current collection ID ${currentCollectionId}.`);

        // --- START CHANGES ---
        // 1. Filter out null/invalid entries FIRST
        const validChipsData = relatedCollectionsData[currentCollectionId].filter(chip => chip && chip.id && chip.title);

        // 2. Reverse the filtered array
        validChipsData.reverse();
        // console.log('[Chips Full] Reversed chipsData ready for rendering:', validChipsData); // Optional debug log
        // --- END CHANGES ---

        chipsContainer.innerHTML = ''; // Clear placeholder

        let chipsAdded = false;
        // Iterate over the REVERSED and filtered array (validChipsData)
        validChipsData.forEach((chip, index) => {
          // console.log(`[Chips Full] Processing chip index ${index} (from reversed list):`, chip);
          // No need to check chip validity again, filter did that
          const chipElement = document.createElement('a');
          chipElement.textContent = chip.title;
          chipElement.classList.add('related-collection-chip');
          chipElement.dataset.collectionId = chip.id;
          chipElement.dataset.collectionTitle = chip.title;
          chipElement.href = '#'; // Prevent navigation until handle is fetched

          // console.log(`[Chips Full] Attaching click listener to chip for ID ${chip.id}`);
          chipElement.addEventListener('click', handleChipClick); // Attach click handler

          chipsContainer.appendChild(chipElement);
          chipsAdded = true;
        }); // End forEach

        if (!chipsAdded) {
          // console.log('[Chips Full] No valid chips were found/added after filtering/reversing.');
          chipsContainer.innerHTML = '<span>No related chips found.</span>';
        } else {
          // console.log('[Chips Full] Finished adding reversed chips.');
        }

      } else {
         // console.log(`[Chips Full] Current collection ID ${currentCollectionId} not found as a key in JSON data.`);
         chipsContainer.innerHTML = '';
         chipsContainer.style.display = 'none';
      }

    } catch (error) {
    //  console.error('[Chips Full] ERROR in loadAndRenderChips:', error);
      chipsContainer.innerHTML = `<p style="color: red;">Error loading related chips data.</p>`;
    }
  } // End loadAndRenderChips

  // --- Event Handler for Chip Clicks (Storefront API call) ---
  async function handleChipClick(event) {
    event.preventDefault();
    const chipElement = event.currentTarget;
    const collectionId = chipElement.dataset.collectionId;
    const collectionTitle = chipElement.dataset.collectionTitle;
    //console.log(`[Chips Full] Chip clicked for Collection ID: ${collectionId}, Title: ${collectionTitle}`); // 15

    chipElement.classList.add('is-loading');
    chipElement.style.pointerEvents = 'none';

    // console.log('[Chips Full] Token being used inside handleChipClick:', storefrontAccessToken);


    const collectionGid = `gid://shopify/Collection/${collectionId}`;
    const graphqlEndpoint = `https://${shopDomain}/api/${apiVersion}/graphql.json`;
    //console.log(`[Chips Full] Calling Storefront API: ${graphqlEndpoint} with GID: ${collectionGid}`); // 16
    //console.log(`[Chips Full] URL constructed for fetch: `, graphqlEndpoint); // Let's call this Log #16.5

    try {
     // console.log(`[Chips Full] URL constructed for fetch: `, graphqlEndpoint);

      const response = await fetch(graphqlEndpoint, {
      method: 'POST',
      // --- FOCUS HERE ---
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken // This line adds the header
      },
      // --- END FOCUS ---
      body: JSON.stringify({
        query: GET_COLLECTION_HANDLE_QUERY,
        variables: { collectionId: collectionGid },
      }),
    });
     // console.log('[Chips Full] Storefront API response status:', response.status, 'OK:', response.ok); // 17

      const result = await response.json();
     // console.log('[Chips Full] Storefront API result:', result); // 18

      if (!response.ok || result.errors) {
       //   console.error('[Chips Full] Storefront API request failed or returned errors.', result.errors || `Status: ${response.status}`);
          throw new Error('GraphQL request failed or returned errors.');
      }

      const handle = result.data?.collection?.handle;
  //    console.log(`[Chips Full] Extracted handle: ${handle}`); // 19

      if (handle) {
     //   console.log(`[Chips Full] Navigating to /collections/${handle}`); // 20
        window.location.href = `/collections/${handle}`;
      } else {
    //    console.warn(`[Chips Full] Handle not found for Collection ID ${collectionId}.`);
        throw new Error('Handle not found in API response.');
      }

    } catch (error) {
     // console.error(`[Chips Full] ERROR in handleChipClick for Collection ID ${collectionId}:`, error); // 21 - IMPORTANT: Check errors here
      alert(`Could not load collection '${collectionTitle}'. Redirecting to search.`);
      const encodedTitle = encodeURIComponent(collectionTitle);
      window.location.href = `/search?type=product&q=${encodedTitle}`;
      chipElement.classList.remove('is-loading');
      chipElement.style.pointerEvents = 'auto';
    }
  }

  // --- Initiate the process ---
  //console.log('[Chips Full] Calling loadAndRenderChips().'); // 22
  loadAndRenderChips();

}); // End DOMContentLoaded